module.exports = __webpack_public_path__ + "img/52.6.CODm.174e5d6e.png";